import { render, staticRenderFns } from "./65.vue?vue&type=template&id=6d5440d8&scoped=true&"
import script from "./65.vue?vue&type=script&lang=js&"
export * from "./65.vue?vue&type=script&lang=js&"
import style0 from "./65.vue?vue&type=style&index=0&id=6d5440d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5440d8",
  null
  
)

export default component.exports